


































































































































































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { isNull } from 'lodash';

import PaginationInterface from '@core/interfaces/pagination-interface';
import { Membership } from '@subscriptions/interfaces/subscription';
import { BPCDisplayConfig } from '@core/interfaces/bpc-display-config';
import { membershipDisplayFields, membershipFilters } from '@/config/subscriptions';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';

import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import GridMock from '@shared/components/mocks/grid-mock/grid-mock.vue';

import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import MultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';

import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
// import MembershipForm from '@subscriptions/components/forms/admin/membership-form.vue';
import moment from 'moment';
import Table from '@shared/components/tables/table.vue';
import MembershipForm from '@subscriptions/components/forms/admin/membership-form.vue';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import DisplayFieldBadge from '@shared/components/displays/display-field-badge/display-field-badge.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import { mixins } from 'vue-class-component';
import { Invoice } from '@accounting/interfaces/invoice';
import MembershipPaymentForm from '@subscriptions/components/forms/admin/membership-payment-form.vue';
import OrderingInterface from '@core/interfaces/ordering-interface';
import { BPCTable, BPCTableField } from '@shared/interfaces/bpc-table-interface';

const defaultTableFields: BPCTableField[] = [
  {
    key: 'contact.fullname',
    headerLabel: `global.subscription.contact_id.label`,
    order: 0,
  },
  {
    key: 'start_date',
    headerLabel: 'global.subscription.start_date.header_label',
    order: 1,
  },
  {
    key: 'end_date',
    headerLabel: 'global.subscription.end_date.header_label',
    order: 2,
  },
  {
    key: 'status',
    headerLabel: `global.status.label`,
    order: 3,
  },
  {
    key: 'paid_amount',
    headerLabel: 'subscriptions.membership.paid_amount.header_label',
    order: 4,
  },
  {
    key: 'balance',
    headerLabel: 'subscriptions.membership.balance.header_label',
    order: 5,
  },
  {
    key: 'price',
    headerLabel: 'global.subscription.subscription_price.label',
    order: 5,
  },
  {
    key: 'payment_status',
    headerLabel: '',
    order: 6,
  },
  {
    key: 'membership_category.name',
    headerLabel: 'global.membership.membership_category.header_label',
    order: 7,
  },
];

@Component({
  name: 'bpc-membership-list',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-grid-mock': GridMock,
    'bpc-entity-select': EntitySelect,
    'bpc-multi-select': MultiSelect,
    'bpc-search-input': SearchInput,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-table': Table,
    'bpc-membership-form': MembershipForm,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-display-field-badge': DisplayFieldBadge,
    'bpc-display-contact-link': DisplayContactLink,
    'bpc-membership-payment-form': MembershipPaymentForm,
  },
})
export default class MembershipList extends mixins(SendMessageUsingTemplateMixin)
  implements BPCTable {
  declare $refs: SendMessageUsingTemplateMixin['$refs'] & {
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    bulkSolfDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };

  // PROPS
  @Prop(Object) readonly externalFormModel: object;
  @Prop({ type: String }) readonly orderBy: string;
  @Prop({ type: String }) readonly orderDirection: string;
  @Prop({ type: Object }) readonly initialFilters: {
    search: string;
    membership_category_id: number;
    contact_id: number;
    status: string;
    membership_payment_status: string;
  };
  @Prop(Object) readonly membershipCategory: MembershipCategory;
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean }) readonly showMembershipCategoryFilter: boolean;
  @Prop({ type: Boolean, default: false }) readonly isInput: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCreateMembershipButton: boolean;
  @Prop({ type: Boolean, default: true }) readonly showCategoryFieldOnForm: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop({ type: Boolean }) readonly withUrlParams: boolean;
  @Prop({ type: Boolean, default: true }) readonly showContactFilter: boolean;
  @Prop({
    default() {
      return defaultTableFields;
    },
  })
  readonly tableFields: BPCTableField[];

  // DATA
  moment: any; // NOTE make moment pipe work with typescript
  loading: boolean = false;
  loadingAccounting: boolean = false;
  urlParams: Record<string, string> = {};
  config: BPCDisplayConfig = null;
  membershipItems: Membership[] = [];

  submittedSearch = '';
  selectedContacts = [];
  selectedStatus = '';
  selectedMembershipCategory = null;
  selectedMembershipPaymentStatus = '';

  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };
  ordering: OrderingInterface = {
    order_by: 'contacts.fullname',
    order_direction: 'asc',
  };

  orderByOptions: object[] = [
    {
      text: this.$t('global.membership.ordering.member.fullname.label'),
      value: 'contacts.fullname',
    },
    { text: this.$t('global.membership.ordering.start_date.label'), value: 'start_date' },
    { text: this.$t('global.membership.ordering.end_date.label'), value: 'end_date' },
  ];

  gridCols: object = {
    sm: 12,
    md: 6,
    lg: 4,
  };

  showDrawerSection = false;
  bulkCreate = false;
  formModel: Partial<Membership> = null;
  timestamp = moment().unix();

  // MOVE to TRASH
  showBulkMoveToTrashModal = false;
  selection = [];
  filterModel = null;
  entityName = 'membership';
  dataToShowInBulkReports = [];
  checkedAllEntities = false;
  searchAndOrderQueryParams = {};

  showAddPaymentForm: boolean = false;
  selectedTicketToPay: Partial<Invoice> = null;

  // LIFECYCLE

  // created() {}
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeOrderingFromProperties();
    this.initializeValuesFromUrlParams();
    this.getMembershipsIfStopChanging();
  }
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get fieldsToShow(): object[] {
    return this.tableFields.sort((f1, f2) => f1.order - f2.order);
  }

  get formCancelPortalTarget(): string {
    return `membership-form-cancel-portal-target-${this.timestamp}`;
  }

  get formActionsPortalTarget(): string {
    return `membership-form-actions-portal-target-${this.timestamp}`;
  }

  get filtersConfig() {
    return membershipFilters;
  }
  get displayConfig() {
    return membershipDisplayFields;
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.ordering.order_by,
      this.ordering.order_direction,
      this.submittedSearch,
      ...this.selectedContacts,
      this.selectedStatus,
      this.selectedMembershipPaymentStatus,
      this.selectedMembershipCategory,
    ].join('--');
  }

  get noLabel() {
    // TODO initialize correctly the "for" attribute in field-wrapper
    return {
      labelAttributes: {
        for: 'test',
      },
    };
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    const entityName = 'membership';
    return {
      id: entityName + '-soft-delete-modal',
      title: this.$t('global.modals.soft-delete.title', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.soft-delete.body', {
        entityName: this.$t('global.models.' + entityName + '.name'),
        entityPluralName: this.$t('global.models.' + entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get selectionCount(): number {
    return (this.checkedItems || []).length;
  }

  get trashFilterSelected(): boolean {
    return this.selectedStatus === 'trash';
  }

  get paymentFormActionButtonsPortalTarget() {
    return `membership-list-payment-form-action-buttons-portal-target-${this.timestamp}`;
  }
  get paymentFormCancelButtonsPortalTarget() {
    return `membership-list-payment-form-cancel-buttons-portal-target-${this.timestamp}`;
  }

  // METHODS
  clickOnEdit(data) {
    this.bulkCreate = false;
    this.formModel = data.item;
    this.showDrawerSection = true;
  }

  onCheckAll(val: boolean) {
    // this.membershipItems = this.membershipItems.map(item => {
    //   this.$set(item, 'checked', val);
    //   return item;
    // });
    this.checkedAllEntities = val;
    // console.log('onCheckAll');
  }

  get checkedItems() {
    return this.membershipItems.filter(item => item.checked);
  }

  initializeOrderingFromProperties() {
    if (this.orderBy) {
      this.ordering.order_by = this.orderBy;
    }

    if (this.orderDirection) {
      this.ordering.order_direction = this.orderDirection;
    }
  }

  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.submittedSearch = this.initialFilters?.search || '';
      this.selectedStatus = this.initialFilters?.status || 'ongoing';
      this.selectedMembershipPaymentStatus = this.initialFilters?.membership_payment_status || '';
      this.selectedMembershipCategory = this.initialFilters?.membership_category_id || null;
      if (this.initialFilters?.contact_id) {
        if (Array.isArray(this.initialFilters?.contact_id)) {
          this.selectedContacts = this.initialFilters?.contact_id;
        } else {
          this.selectedContacts = [this.initialFilters?.contact_id];
        }
      } else {
        this.selectedContacts = [];
      }
    }
  }

  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUlrParams();
      if (!this.submittedSearch) {
        this.submittedSearch = urlParams?.search || '';
      }
      if (!this.selectedStatus) {
        this.selectedStatus = urlParams?.status || 'ongoing';
      }
      if (!this.selectedMembershipPaymentStatus) {
        this.selectedMembershipPaymentStatus = urlParams?.membership_payment_status || '';
      }
      if (!this.selectedMembershipCategory) {
        this.selectedMembershipCategory = urlParams?.membership_category_id || null;
      }
      if (!this.orderBy) {
        this.ordering.order_by = urlParams?.order_by || 'contacts.fullname';
      }
      if (!this.orderDirection) {
        this.ordering.order_direction = urlParams?.order_direction || 'asc';
      }

      if (!this.selectedContacts) {
        if (urlParams?.contact_id) {
          if (Array.isArray(urlParams?.contact_id)) {
            this.selectedContacts = urlParams?.contact_id;
          } else {
            this.selectedContacts = [urlParams?.contact_id];
          }
        } else {
          this.selectedContacts = [];
        }
      }
    }
  }

  getMembershipsIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getMemberships();
      }
    }, 300);
  }

  // First call
  async getMemberships() {
    this.loading = true;
    this.checkedAllEntities = false;
    this.loadingAccounting = true;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('membership');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.membershipItems = res.data.map(item => {
      return {
        ...item,
        paid_amount: null,
        balance: null,
        ticket_ids: [],
      };
    });
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
    await this.getMembershipAccounting();
  }

  // Second call (for accounting data)
  async getMembershipAccounting() {
    this.loadingAccounting = true;
    const membershipIds = this.membershipItems.map(item => item.id);
    const params = {
      ids: membershipIds,
    };
    const url = `${this.$bpcApiRouteHelper.getEntityPath('membership')}/accounting`;
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.membershipItems = this.membershipItems.map(item => {
      if (res.data[item.id]) {
        return {
          ...item,
          paid_amount: res.data[item.id].paid_amount,
          balance: res.data[item.id].balance,
          ticket_ids: res.data[item.id].ticket_ids,
        };
      } else {
        return {
          ...item,
          paid_amount: null,
          balance: null,
          ticket_ids: res.data[item.id].ticket_ids,
        };
      }
    });
    this.loadingAccounting = false;
  }

  getQueryParams() {
    return {
      order_by: this.ordering.order_by,
      order_direction: this.ordering.order_direction,
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.submittedSearch,
      membership_category_id: this.selectedMembershipCategory,
      contact_id: this.selectedContacts,
      status: this.selectedStatus,
      membership_payment_status: this.selectedMembershipPaymentStatus,
    };
  }

  getUlrParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }

  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }

  clickOnReload() {
    this.getMembershipsIfStopChanging();
  }

  clickOnView(item) {
    const routeName = 'admin-membership';
    const tenant = this.$authService.getSelectedTenant();
    return {
      name: routeName,
      params: {
        tenantAlias: tenant.alias,
        id: item.id,
        item: item,
      },
    };
  }

  clickOnCreate() {
    this.bulkCreate = false;
    this.formModel = {
      subscription_category_id: this.selectedMembershipCategory,
      price: this.membershipCategory?.price || 0,
      status: 'ongoing',
    };
    this.showDrawerSection = true;
  }

  clickOnBulkCreate() {
    this.bulkCreate = true;
    this.formModel = {
      member_ids: [],
      subscription_category_id: this.selectedMembershipCategory,
      price: this.membershipCategory?.price || 0,
      status: 'ongoing',
    };
    if (this.isInput && this.externalFormModel) {
      this.formModel.member_ids.push(this.externalFormModel['id']);
    }
    this.showDrawerSection = true;
  }

  clickOnQuickEdit(item) {
    this.bulkCreate = false;
    this.formModel = item;
    this.showDrawerSection = true;
  }

  clickOnSoftDelete(item) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.id);
  }
  clickOnBulkSoftDelete() {
    const ids = this.checkedItems.map(item => item.id);
    this.$refs.bulkSolfDeleteConfirmationModal.onOpenModal(ids);
  }

  onEntitySaved() {
    this.$emit('entity-saved');
    this.getMembershipsIfStopChanging();
  }

  onPaymentSaved() {
    this.$emit('entity-saved');
    this.getMembershipAccounting();
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.getMembershipsIfStopChanging();
  }
  onSuccessBulkSoftDelete() {
    this.$refs.bulkSolfDeleteConfirmationModal.onCloseModal();
    this.getMembershipsIfStopChanging();
  }

  onCloseModal() {
    this.formModel = null;
    this.showDrawerSection = false;
  }

  clickOnBulkMoveToTrash() {
    this.selection = this.checkedItems.map(item => item.id);
    this.filterModel = this.getQueryParams();
    this.dataToShowInBulkReports = [['code']];
    this.searchAndOrderQueryParams = this.getQueryParams();
    this.showBulkMoveToTrashModal = true;
  }

  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
    this.getMembershipsIfStopChanging();
  }

  async onSendMessageUsingTemplate(data) {
    this.sendMessageUsingTemplateSelectedItemIds = [data.item.id];
    this.contactsToSendMessageUsingTemplate = [data.item.contact_id];
    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  async onAddPayment(data) {
    const isSingleTicket = (data.item?.ticket_ids || []).length === 1;
    if (!isSingleTicket) {
      // NOTE if the membership has more than one invoice (not the normal case)
      // we open the edition form to choose which invoice has to be paid
      this.clickOnEdit(data);
    } else {
      const ticket = {
        balance: data.item.balance,
        contact_id: data.item.contact_id,
        id: data.item.ticket_ids[0],
      };
      this.selectedTicketToPay = ticket;
      this.showAddPaymentForm = true;
    }
  }

  closeAddPaymentForm() {
    this.showAddPaymentForm = false;
  }

  async onBulkSendMessageUsingTemplateToMemberships() {
    this.sendMessageUsingTemplateSelectedItemIds = this.checkedItems.map(item => item.id);
    this.contactsToSendMessageUsingTemplate = this.checkedItems.map(item => item.contact_id);

    this.sendMessageUsingTemplateCleanErrors();
    this.openSendMessageUsingTemplateDrawer();
  }

  clickOnChangeOrderDirection(direction) {
    this.ordering.order_direction = direction;
  }

  // WATCHERS

  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val) {
    if (val) {
      this.getMembershipsIfStopChanging();
    }
  }
}
